import { RootState } from "store/rootReducer";

export const selectHolidays = (state: RootState) => state.holidays;
